import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export default function Unauthorised() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "100px" }}>
      <Result
        status="403"
        title="403 - Access Denied"
        subTitle="You do not have permission to view this page."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back Home
          </Button>
        }
      />
    </div>
  );
}
